<template>
  <div class="exchange">
    <lending/>
    <detail-btn @clickHandle="setShowDetail" @refresh="refresh" label="View my History" class="upper" style="margin:0.4rem 0 1.2rem 0;"/>
    <detail v-if="showDetail" ref="depositDetail"/>
  </div>
</template>

<script>
import lending from "./deposit.vue"
import detail from "./detail.vue"
import detailBtn from "@/components/DetailBtn/index.vue"
export default {
  components: {
    lending,
    detail,
    detailBtn
  },
  data() {
    return {
      showDetail:false,
    };
  },
  computed: {

  },
  methods: {
    setShowDetail(){
      if(this.showDetail){
        this.$nextTick(() => {
          this.refresh();
        })
      }else{
        this.showDetail = true;
      }
    },
    refresh(){
      this.$refs.depositDetail && this.$refs.depositDetail.refresh();
    }

  },
  created() {
    if(this.$route.query.detail == 1){
      this.setShowDetail();
    }
  },
  mounted() {}
};
</script>
<style scoped lang="scss">

</style>
